module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-22.74b4e331.jpg";